import ptApiClient from 'plant-api-client';

export const CustomIdUpdateStatus = Object.freeze({
	success: 'success',
	error: 'error'
});

export function isValidCustomId(customId) {
	const regex = /^[A-Za-z0-9 &_.-]+$/;
	return regex.test(customId);
}

export async function forceUpdateCustomId(oldCustomId, newCustomId) {
	try {
		const data = await ptApiClient.forceUpdateCustomId(oldCustomId, newCustomId);

		return {
			status: CustomIdUpdateStatus.success,
			data
		};
	} catch (error) {
		console.error(error);

		return {
			status: CustomIdUpdateStatus.error,
			error: getCustomIdUpdateErrorMessage(error)
		};
	}
}

export async function existsCustomId(customId) {
	try {
		await ptApiClient.getContentByCustomId(customId, true);
		return true;
	} catch (e) {
		return false;
	}
}

function getCustomIdUpdateErrorMessage(error) {
	if (error && error.response && error.response.data && error.response.data.message) {
		return error.response.data.message;
	}

	if (error && error.message) {
		return error.message;
	}

	return 'Unexpected error updating custom ID';
}
